import { useGetQuantifyLeftActions } from './useGetQuantifyLeftActions';
import { useGetQuantifyMoreActions } from './useGetQuantifyMoreActions';
import { useGetQuantifyRightActions } from './useGetQuantifyRightActions';

export const useGetQuantifyAnalysisActions = () => {
  const leftActions = useGetQuantifyLeftActions();
  const rightActions = useGetQuantifyRightActions();
  const moreActions = useGetQuantifyMoreActions();

  return {
    leftActions,
    rightActions,
    moreActions,
  };
};
